<template>
  <div class="faq-jumbotron">
    <div class="faq-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
      <h1 class="mb-1 text-white">{{ $t('faq.have-any-question') }}</h1>
      <p class="text-white">{{ $t('faq.we-provide-some-faq') }}</p>
      <vs-input @input="$emit('onSearchInput', search)"
                class="w-full mt-6"
                icon="icon-search"
                icon-no-border
                icon-pack="feather"
                placeholder="Search"
                size="large"
                v-model="search"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SearchFaqJumbotron",
    props: [
      'faqSearchQuery'
    ],
    data() {
      return {
        search: '',
      };
    },
  }
</script>

<style scoped>

</style>
